<div class="card-title">
  <!-- card title img -->
  @if (cardTitleData()?.image) {
    <div class="card-title__img-container {{ cardTitleData()?.imgClasses }}">
      <img
        class="card-title__img"
        [ngClass]="cardTitleData()?.imgClasses"
        [width]="cardTitleData()?.image?.width || 88"
        [height]="cardTitleData()?.image?.height || 88"
        [ngSrc]="
          cardTitleData()?.image?.src
            | imageSource
              : true
              : 'md'
              : cardTitleData()?.image?.defaultNoProfileImage
        "
        [alt]="(cardTitleData()?.image?.alt | translateData) || 'logo'" />
    </div>
  }
  <!-- card title content -->
  <div class="card-title__content">
    <!-- title -->
    <h3 class="content-title" [ngClass]="cardTitleData()?.titleClasses">
      @if (cardTitleData()?.titleMarquee; as titleMarquee) {
        <pwj-marquee-text
          class="content-title__marquee"
          [text]="(cardTitleData()?.title | translateData) || ''"
          [contextActive]="titleMarquee.contextActive">
        </pwj-marquee-text>
      } @else {
        <pwj-text-summarizer
          [text]="cardTitleData()?.title | translateData"
          [truncate]="cardTitleData()?.titleTruncate ?? false"
          [ngClass]="{ 'content-title__text': cardTitleData()?.summarizeTitle }"
          [limitLength]="cardTitleData()?.summarizeTitleLength || 20">
        </pwj-text-summarizer>
      }

      @if (cardTitleData()?.code) {
        <span class="content-title__code">
          ( {{ cardTitleData()?.code }})
        </span>
      }
    </h3>
    <!-- sub title -->

    <div class="content-subtitle" [ngClass]="cardTitleData()?.subTitleClasses">
      @if (cardTitleData()?.subTitleUrl) {
        <a [routerLink]="cardTitleData()?.subTitleUrl">
          <pwj-text-summarizer
            [text]="cardTitleData()?.subTitle | translateData"
            [truncate]="cardTitleData()?.subTitleTruncate ?? false"
            [ngClass]="{
              'content-subtitle__text': cardTitleData()?.summarizeTitle,
            }"
            [limitLength]="cardTitleData()?.summarizeSubTitleLength || 20">
          </pwj-text-summarizer>
        </a>
      } @else {
        <pwj-text-summarizer
          [text]="cardTitleData()?.subTitle | translateData"
          [truncate]="cardTitleData()?.subTitleTruncate ?? false"
          [ngClass]="{
            'content-subtitle__text': cardTitleData()?.summarizeTitle,
          }"
          [limitLength]="cardTitleData()?.summarizeSubTitleLength || 20">
        </pwj-text-summarizer>
      }

      <!-- verify icon -->
      @if (cardTitleData()?.isVerified) {
        <img
          class="content-subtitle__icon"
          ngSrc="assets/icons/verify.svg"
          width="20"
          height="20"
          alt="verify" />
      }
    </div>
  </div>
</div>
